// site scss bundle - will be extracted into a css file by ExtractTextPlugin
import '../c/main.scss'

import './util/polyfills'

import './src/feed'
import './src/pages'
import './src/project'
import './src/site'



// WEBPACK FOOTER //
// ./assets/j/main.js